// AYA Arts & Entertainment - Brand Constants

export const BRAND = {
  name: "AYA",
  fullName: "Designed and Built by AYA Arts & Entertainments",
  tagline: "Discover. Book. Host. Track your journey. All in one place.",
  pronunciation: "A·Y·A /ā-wī-ā/",
  sayItLike: "Say it like: A – Y – A"
};

export const COLORS = {
  background: "#000000",
  surface: "#0B0B0B",
  primary: "#ffde59",
  foreground: "#FFFFFF",
  muted: "#525252",
  border: "#333333"
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/ayadance.in/",
  email: "support@ayadance.in"
};

export const COPY = {
  hero: {
    definition: "The dance ecosystem, organized.",
    subtext: "A platform built to connect artists, studios & anyone who loves dancing."
  },
  problem: {
    title: "Let's get to know you first!",
    prompt: "Who are you?",
    roles: ["I am an Artist", "I own a Studio", "I just love to Dance"],
    dancer: [
    "Classes live in posters + stories + forwards.",
    "Booking means 'DM to confirm' + UPI screenshots.",
    "Hard to track what you've learnt this month.",
    "No streaks. No progress trail. No rewards.",
    "Feedback gets lost or never reaches the teacher.",
    "Finding the right level/style is guesswork."],

    artist: [
    "Still managing bookings on WhatsApp?",
    "Replying to DMs all day just to fill slots?",
    "Last-minute drop-offs ruin planning.",
    "No clean system for waitlists, refunds, confirmations.",
    "Paying managers or losing time to admin.",
    "Hard to communicate updates without chaos."],

    studio: [
    "Schedules + payments + capacity tracked in spreadsheets.",
    "Cancellations and waitlists are manual.",
    "No unified view of bookings across instructors.",
    "Hard to retain students without a system.",
    "You spend time on admin instead of growth + marketing."],

    conclusion: "Yep. That's exactly what we're fixing."
  },
  solution: {
    title: "How AYA solves it",
    cards: [
    {
      title: "One place to discover & book",
      description: "Classes, workshops, intensives—organized by style, level, vibe.",
      icon: "Calendar"
    },
    {
      title: "A system for hosting & management",
      description: "Schedules, capacity, waitlists, payments—without chasing DMs.",
      icon: "Settings"
    },
    {
      title: "Your dance journey, saved",
      description: "Attendance history, streaks, progress, and community rewards.",
      icon: "Trophy"
    }],

    comingSoon: "We're building quietly. Launching loudly."
  },
  waitlist: {
    title: "Wanna stay in the loop?",
    promise: "dance stays the same, the process gets simpler!",
    button: "Join the Waitlist",
    success: "You're in. We'll reach out before the first drop.",
    privacy: "No spam. Only updates worth opening."
  },
  socialProof: {
    title: "Built by the community, for the community.",
    subtitle: "a platform that dance deserves.",
    badges: ["Community-first", "Artist-led", "Studio-friendly"]
  },
  footer: {
    tagline: "AYA — A. Y. A.",
    links: ["Instagram", "Email", "Terms", "Privacy"]
  }
};

export const NAV_LINKS = [
// { label: "How it works", href: "#solution" },
// { label: "For who?", href: "#problem" },
{ label: "Join the Waitlist", href: "#waitlist" }];
